import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { browserHistory } from "react-router";
import { Chart } from "primereact/chart";
import axios from "axios";
import * as appConst from "../../Common/constants";

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accountData: "NA",
      validTill: "",
      validityClass: "collapse"
    };
  }

  componentDidMount() {
    let currentComponent = this;
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/dashboard"
      )
      .then(response => {
        currentComponent.setState({ accountData: response.data });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {

    var dataTD, dataMTD;

    if (this.state.accountData !== "NA") {
      dataTD = {
        labels: ["Expense", "Income"],
        datasets: [
          {
            data: [
              this.state.accountData.TD.expense,
              this.state.accountData.TD.income
            ],
            backgroundColor: ["#FF6384", "#2ECC71"],
            hoverBackgroundColor: [
              "#FF6384",
              "#2ECC71",
            ]
          }
        ]
      };

      dataMTD = {
        labels: ["Expense", "Income"],
        datasets: [
          {
            data: [
              this.state.accountData.MTD.expense,
              this.state.accountData.MTD.income
            ],
            backgroundColor: ["#FF6384", "#2ECC71"],
            hoverBackgroundColor: [
              "#FF6384",
              "#2ECC71",
            ]
          }
        ]
      };
    }

    const optionsMonth = {
      title: {
        display: true,
        text: "Current Month",
        fontSize: 20
      },
      legend: {
        position: "bottom"
      }
    };

    const optionsAll = {
      title: {
        display: true,
        text: "Over All",
        fontSize: 20
      },
      legend: {
        position: "bottom"
      }
    };

    return (
      <div className="h-100 container-fluid">
        <div className="row p-1 ">
          <div className="col col-md-6 border">
            <Chart type="pie" data={dataMTD} options={optionsMonth} />
          </div>
          <div className="col col-md-6 border">
            <Chart type="pie" data={dataTD} options={optionsAll} />
          </div>
        </div>
        <div className="row ">
          <div></div>
        </div>
      </div>
    );
  }
}

export default Home;
